// removed by extract-text-webpack-plugin
module.exports = {"bg":"rgba(14,106,180,.9)","color":"#fff","hover":"rgba(56,66,76,.9)","active":"#ffd04b","btnColor":"primary"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7e55a170","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/dzy/views/Layout/components/Header.vue
// module id = nKvK
// module chunks = 43